import React from 'react'
import Card from '../components/card'
import DoughnutChart from '../components/doughnut-chart'
import style from '../ResumenADN.module.css'
import Subtitle from '../../../components/Subtitle/Subtitle'

const AlcanzarPropositos = ({ loaded, data }) => (
  <Card>
    <Subtitle sname="Para alcanzar tus própositos" mostrar="true"></Subtitle>
    {loaded ? <DoughnutChart data={data} /> : <div className={style.loadChart}>Cargando gráfico...</div>}
  </Card>
)

export default AlcanzarPropositos
